export const LINE_END_POINT_SIZE = 12;
export const DEFAULT_LINE_HEIGHT = 6;
export const DEFAULT_LINE_WIDTH = 500;

export enum LineCapStyle {
  NONE = 'none',
  ARROW = 'arrow',
  CIRCLE = 'circle',
  SQUARE = 'square',
  DIAMOND = 'diamond',
  T_BAR = 't_bar',
  FILLED_ARROW = 'filled_arrow',
  FILLED_CIRCLE = 'filled_circle',
  FILLED_SQUARE = 'filled_square',
  FILLED_DIAMOND = 'filled_diamond',
}

export enum LineDashType {
  NONE = 'none',
  DASH = 'dash',
  LONG_DASH = 'long_dash',
  DOTED = 'doted',
  DOT_DASH = 'dot_dash',
  CUSTOM = 'custom',
}

interface LineCapStyleToOffsetScaleMap {
  offset: number;
}

export const LINE_CAP_STYLE_TO_OFFSET_SCALE_HASHMAP: Record<LineCapStyle, LineCapStyleToOffsetScaleMap> = {
  [LineCapStyle.ARROW]: {
    offset: 0.3,
  },
  [LineCapStyle.CIRCLE]: {
    offset: 1.9,
  },
  [LineCapStyle.SQUARE]: {
    offset: 1.8,
  },
  [LineCapStyle.DIAMOND]: {
    offset: 1.8,
  },
  [LineCapStyle.T_BAR]: {
    offset: 0.3,
  },
  [LineCapStyle.FILLED_ARROW]: {
    offset: 0.8,
  },
  [LineCapStyle.FILLED_CIRCLE]: {
    offset: 1.8,
  },
  [LineCapStyle.FILLED_SQUARE]: {
    offset: 1.8,
  },
  [LineCapStyle.FILLED_DIAMOND]: {
    offset: 1.8,
  },
  [LineCapStyle.NONE]: {
    offset: 1,
  },
};
